import { Button } from "nazare-ui/primitives";
import { workflowRunControlAction } from "../../../../workflow-run-control";
import { usePauseWorkflowRun, useResumeWorkflowRun, type RunSummary } from "../../../../workflows-api";
import styles from "./run-detail.module.css";

export function RunPauseControl({ run }: { run: RunSummary }) {
  const pause = usePauseWorkflowRun();
  const resume = useResumeWorkflowRun();
  const action = workflowRunControlAction(run);
  if (action === null) return null;
  const pending = pause.isPending || resume.isPending;
  const error = pause.error ?? resume.error;

  return (
    <div className="flex max-w-full flex-col items-end gap-1">
      <Button
        className={styles.workflowButton}
        variant="outline"
        disabled={pending}
        onClick={() => {
          pause.reset();
          resume.reset();
          (action === "pause" ? pause : resume).mutate(run.runId);
        }}
      >
        {pause.isPending ? "Requesting pause…" : resume.isPending ? "Resuming…" : action === "pause" ? "Pause run" : "Resume run"}
      </Button>
      {error && <span role="alert" className="max-w-sm text-right text-[12px] text-[var(--red)]">{error.message}</span>}
    </div>
  );
}
